<app-loader *ngIf="loading"></app-loader>


<mdb-tabset [buttonClass]="'classic-tabs tabs-grey'" [contentClass]="'card'" class="classic-tabs custom-tabset header">
    <!--PESTAÑA INFORMACION-->
    <mdb-tab heading="<i class='fas fa-book mr-2'></i> Información">
        <ng-container *ngIf="formClient">
            <form [formGroup]="formClient">
                <mdb-card class="z-depth-0">
                    <mdb-card-header class="blue-grey-text white border-bottom border-primary">
                        <div class="row">
                            <mdb-checkbox [default]="true" formControlName="enabled"><b style="color: gray;">Cliente activo</b></mdb-checkbox>
                            <mdb-checkbox class="ml-3" [default]="true" formControlName="web_access" (change)="changeWebAccess($event)"><b style="color: gray;">Acceso web</b></mdb-checkbox>
                        </div>
                    </mdb-card-header>
                </mdb-card>
               
                <div class="row mt-2">
                    <div class="col-lg">
                        <div class="md-form md-outline">
                            <input mdbInput type="text" id="identification_document" formControlName="identification_document" class="form-control form-control-sm" placeholder="">
                            <label for="identification_document" class="">NIF</label>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form md-outline">
                            <input mdbInput type="text" id="clientname" formControlName="name" class="form-control form-control-sm" mdbValidate [validateSuccess]="false" placeholder="">
                            <label for="clientname" class="">Nombre</label>
                            <mdb-error *ngIf="formClient.controls.name.invalid&& (formClient.controls.name.dirty || formClient.controls.name.touched)">Campo obligatorio</mdb-error>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form md-outline">
                            <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="clientsurname" formControlName="surname" class="form-control form-control-sm" placeholder="">
                            <label for="clientsurname" class="">Apellidos</label>
                            <mdb-error *ngIf="formClient.controls.surname.invalid&& (formClient.controls.surname.dirty || formClient.controls.surname.touched)">Debe introducir el apellido al dar acceso web</mdb-error>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg">
                        <div class="md-form md-outline">
                            <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="clientemail" formControlName="email" class="form-control form-control-sm" placeholder="">
                            <label for="clientemail" class="">Email</label>
                            <mdb-error *ngIf="formClient.controls.email.invalid && (formClient.controls.email.dirty || formClient.controls.email.touched)">
                              <ng-container *ngFor="let error of formClient.controls.email.errors | keyvalue">
                                <ng-container [ngSwitch]="error.key">
                                  <ng-container *ngSwitchCase="'required'">Campo Obligatorio</ng-container>
                                  <ng-container *ngSwitchCase="'email'">Introduce un email válido</ng-container>
                                  <ng-container *ngSwitchCase="'data_exists'">El email introducido ya está en uso</ng-container>

                                </ng-container>
                              </ng-container>

                            </mdb-error>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form md-outline">
                            <input mdbInput type="text" id="clientphone" formControlName="phone" class="form-control form-control-sm" placeholder="">
                            <label for="clientphone" class="">Teléfono</label>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form md-outline">
                            <input mdbInput type="text" id="clientmobile" formControlName="mobile" class="form-control form-control-sm" placeholder="">
                            <label for="clientmobile" class="">Móvil</label>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <div class="md-form md-outline">
                            <textarea type="text" id="observations" rows="15" formControlName="observations" placeholder="" class="md-textarea form-control" mdbInput></textarea>
                            <label for="observations">Observaciones</label>
                        </div>
                    </div>
                    
                    <div class="col-md-6">
                        <app-gmaps-component #maps></app-gmaps-component>
                    </div>
                </div>
            </form>
        </ng-container>
    </mdb-tab>
    
    <!--PESTAÑA DIRECCIONES-->
    <mdb-tab heading="<i class='fas fa-map-marked-alt mr-2'></i> Direcciones">
        <app-client-addresses [addresses]="addresses" [readonly]="formClient.disabled" [client_id]="id" (loading)="loading = $event" (reload_map)="LoadAddressesOnMap($event)"></app-client-addresses>
        <!--<div  class="mt-4" style="height: 500px;">
            <app-gmaps-component #map [mapOptions]="mapOptions" [googleMapMarkerPositions]="googleMapMarkerPositions" [googleMapMarkerOptions]="googleMapMarkerOptions"></app-gmaps-component>
        </div>-->
    </mdb-tab>

    <!--PESTAÑA CONTACTOS-->
    <mdb-tab heading="<i class='fas fa-address-book mr-2'></i> Contatos">
        <app-client-contacts [contacts]="contacts" [readonly]="formClient.disabled" [client_id]="id" (loading)="loading = $event"></app-client-contacts>
    </mdb-tab>

    <!--PESTAÑA POLIZAS-->
    <ng-container *appModules="['companies']">
        <mdb-tab heading="<i class='fas fa-file-signature'></i> Pólizas">
            <app-client-policies [policies]="policies" [readonly]="formClient?.disabled" [client_id]="id" (loading)="loading = $event"></app-client-policies>
        </mdb-tab>
    </ng-container>

    <!--PESTAÑA DOCUMENTOS-->
    <mdb-tab heading="<i class='fas fa-file'></i> Documentos">
        <app-client-documents [documents]="documents" [readonly]="formClient?.disabled" [id]="id" [parent_entity]="data.entity" [entity_endpoint]="'clientsdocuments'" (loading)="loading = $event"></app-client-documents>
    </mdb-tab>

</mdb-tabset>



<!--
<div class="pt-2">

        <mdb-tabset [buttonClass]="'md-tabs pills-primary white mb-2'" [contentClass]="'card'">

            <mdb-tab heading="<i class='fas fa-info-circle'></i> Datos generales">
              <ng-container *ngIf="formClient">
              <form [formGroup]="formClient">
                <div class="row">
                    <div class="col-lg-2">
                        <mdb-checkbox [default]="true" formControlName="enabled" (change)="changeEnabled($event)">Activo
                        </mdb-checkbox>

                    </div>
                    <div class="col-lg">
                        <div class="md-form">
                            <input mdbInput type="text" id="identification_document" formControlName="identification_document" class="form-control form-control-sm" placeholder="">
                            <label for="identification_document" class="">NIF</label>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form">
                            <input mdbInput type="text" id="clientname" formControlName="name" class="form-control form-control-sm" mdbValidate [validateSuccess]="false" placeholder="">
                            <label for="clientname" class="">Nombre</label>
                            <mdb-error *ngIf="formClient.controls.name.invalid&& (formClient.controls.name.dirty || formClient.controls.name.touched)">
                                Campo obligatorio</mdb-error>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form">
                            <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="clientsurname" formControlName="surname" class="form-control form-control-sm" placeholder="">
                            <label for="clientsurname" class="">Apellidos</label>
                            <mdb-error *ngIf="formClient.controls.surname.invalid&& (formClient.controls.surname.dirty || formClient.controls.surname.touched)">
                                Debe introducir el apellido al dar acceso web</mdb-error>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-2">
                        <mdb-checkbox [default]="true" formControlName="web_access" (change)="changeWebAccess($event)">Acceso web
                        </mdb-checkbox>
                    </div>
                    <div class="col-lg">
                        <div class="md-form">
                            <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="clientemail" formControlName="email" class="form-control form-control-sm" placeholder="">
                            <label for="clientemail" class="">Email</label>
                            <mdb-error *ngIf="formClient.controls.email.invalid && (formClient.controls.email.dirty || formClient.controls.email.touched)">
                              <ng-container *ngFor="let error of formClient.controls.email.errors | keyvalue">
                                <ng-container [ngSwitch]="error.key">
                                  <ng-container *ngSwitchCase="'required'">Campo Obligatorio</ng-container>
                                  <ng-container *ngSwitchCase="'email'">Introduce un email válido</ng-container>
                                  <ng-container *ngSwitchCase="'data_exists'">El email introducido ya está en uso</ng-container>

                                </ng-container>
                              </ng-container>

                            </mdb-error>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form">
                            <input mdbInput type="text" id="clientphone" formControlName="phone" class="form-control form-control-sm" placeholder="">
                            <label for="clientphone" class="">Teléfono</label>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="md-form">
                            <input mdbInput type="text" id="clientmobile" formControlName="mobile" class="form-control form-control-sm" placeholder="">
                            <label for="clientmobile" class="">Móvil</label>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-3">
                    <div class="md-form md-outline">
                      <textarea type="text" id="observations" rows="10" formControlName="observations" placeholder="" class="md-textarea form-control" mdbInput></textarea>
                      <label for="observations">Observaciones</label>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col">
                          <app-client-addresses [addresses]="addresses" [readonly]="formClient.disabled" [client_id]="id" (loading)="loading = $event"></app-client-addresses>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col">
                          <app-client-contacts [contacts]="contacts" [readonly]="formClient.disabled" [client_id]="id" (loading)="loading = $event"></app-client-contacts>
                      </div>
                  </div>
                  </div>

                </div>
               <!--  <div class="row mt-3">
                    <div class="col">
                        <app-client-addresses [addresses]="addresses" [readonly]="formClient.disabled" [client_id]="id" (loading)="loading = $event"></app-client-addresses>
                    </div>
                </div>
                <div class="row  mt-3">
                    <div class="col">
                        <app-client-contacts [contacts]="contacts" [readonly]="formClient.disabled" [client_id]="id" (loading)="loading = $event"></app-client-contacts>
                    </div>
                </div> -->
<!--              </form>
              </ng-container>
            </mdb-tab>
            <ng-container *appModules="['companies']">
                <mdb-tab heading="<i class='fas fa-file-signature'></i> Pólizas">
                    <app-client-policies [policies]="policies" [readonly]="formClient?.disabled" [client_id]="id" (loading)="loading = $event"></app-client-policies>
                </mdb-tab>
            </ng-container>
            <mdb-tab heading="<i class='fas fa-file'></i> Documentos">
                <app-client-documents [documents]="documents" [readonly]="formClient?.disabled" [id]="id" [parent_entity]="data.entity" [entity_endpoint]="'clientsdocuments'" (loading)="loading = $event"></app-client-documents>
            </mdb-tab>
        </mdb-tabset>
</div>
-->